export let schemaKey =  Symbol('schema');
export let fieldsKey =  Symbol('fields');
export let submittedKey =  Symbol('submitted');
export let colorKey =  Symbol('color');